import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Header from "./header/Header";
import MainSummary from "./summary/MainSummary";
import Introduction from "./content/Introduction";
import Creative from "./content/Creative";
import Footer from "../footer/Footer";
import Donation from "./content/Donation";
import News from "./content/News";
import MainRouterContainer from "./MainRouter.css";

const MainRouter = () => {
  const navs = [
    {
      address: "introduction",
      components: Introduction,
      title: "협회소개"
    },
    {
      address: "creative",
      components: Creative,
      title: "창조경영"
    },
    {
      address: "donation",
      components: Donation,
      title: "후원하기"
    },
    {
      address: "news",
      components: News,
      title: "소식"
    }
  ];
  return (
    <MainRouterContainer>
      <Router>
        {/* 주소 이동할 헤더 부분 */}
        <Header navs={navs}></Header>
        {/* 메인 컴포넌트 부분 */}
        <div className="MainContainer">
          <Switch>
            {/* 사이트 진입시 볼 화면 부분 ( 이미지 ) */}
            <Route exact path="/">
              <div className="DefaultRoute">
                <h1>리뉴얼 중입니다...</h1>
              </div>
              <MainSummary></MainSummary>
            </Route>
            {navs.map((data, index) => (
              <Route
                path={`/${data.address}`}
                key={index}
                component={data.components}
              ></Route>
            ))}
          </Switch>
        </div>

        {/* 바텀 요약 부분 */}
        <Footer></Footer>
      </Router>
    </MainRouterContainer>
  );
};

export default MainRouter;
